import AD_FLOW_NAMES from '../../consts/uam/advanceDiagnosticFlowNames';
import * as advanceDiagnosticScreenTypes from '../../consts/yap/advanceDiagnosticScreenTypes';

export const SUCCESS_FLOW = {
    name: AD_FLOW_NAMES.SUCCESS_FLOW,
    screens: [
        {
            index: 1,
            name: advanceDiagnosticScreenTypes.FWU_CHECK_SCREEN,
            nextIndex: 2,
            noFwuNextIndex: 3,
        },
        {
            index: 2,
            name: advanceDiagnosticScreenTypes.FWU_SCREEN,
        },
        {
            index: 3,
            name: advanceDiagnosticScreenTypes.NO_ERRORS_SCREEN,
        },
    ],
};

export const MARKET_FLOW = {
    name: AD_FLOW_NAMES.MARKET_FLOW,
    screens: [
        {
            name: advanceDiagnosticScreenTypes.MARKET_SCREEN,
        },
    ],
};

export const FWU_CHECK_AND_RESET_FLOW = {
    name: AD_FLOW_NAMES.FWU_CHECK_AND_RESET_FLOW,
    screens: [
        {
            index: 1,
            name: advanceDiagnosticScreenTypes.FWU_CHECK_SCREEN,
            nextIndex: 2,
            noFwuNextIndex: 3,
        },
        {
            index: 2,
            name: advanceDiagnosticScreenTypes.FWU_SCREEN,
            nextIndex: 4,
        },
        {
            index: 3,
            name: advanceDiagnosticScreenTypes.RESET_SCREEN,
            nextIndex: 4,
        },
        {
            index: 4,
            name: advanceDiagnosticScreenTypes.FINISH_SCREEN,
        },
    ],
};

export const FWU_CHECK_AND_MARKET_FLOW = {
    name: AD_FLOW_NAMES.FWU_CHECK_AND_MARKET_FLOW,
    screens: [
        {
            index: 1,
            name: advanceDiagnosticScreenTypes.FWU_CHECK_SCREEN,
            nextIndex: 2,
            noFwuNextIndex: 3,
        },
        {
            index: 2,
            name: advanceDiagnosticScreenTypes.FWU_SCREEN,
            nextIndex: 4,
        },
        {
            index: 3,
            name: advanceDiagnosticScreenTypes.MARKET_SCREEN,
        },
        {
            index: 4,
            name: advanceDiagnosticScreenTypes.FINISH_SCREEN,
        },
    ],
};

export const FWU_CHECK_AND_ADAPTOR_MSG_FLOW = {
    name: AD_FLOW_NAMES.FWU_CHECK_AND_ADAPTOR_MSG_FLOW,
    screens: [
        {
            index: 1,
            name: advanceDiagnosticScreenTypes.FWU_CHECK_SCREEN,
            nextIndex: 2,
            noFwuNextIndex: 4,
        },
        {
            index: 2,
            name: advanceDiagnosticScreenTypes.FWU_SCREEN,
            nextIndex: 5,
        },
        {
            index: 4,
            name: advanceDiagnosticScreenTypes.ADAPTOR_MSG_SCREEN,
            nextIndex: 5,
        },
        {
            index: 5,
            name: advanceDiagnosticScreenTypes.FINISH_SCREEN,
        },
    ],
};
